import script from "./supportPlatform.vue?vue&type=script&setup=true&lang=js"
export * from "./supportPlatform.vue?vue&type=script&setup=true&lang=js"

import "./supportPlatform.vue?vue&type=style&index=0&id=0a57e104&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a57e104"]])

export default __exports__